import React, { useContext, useEffect, useState } from "react";
import OrderField from "../shared/order_field";
import { useQuery } from "@tanstack/react-query";
import { OrderContext } from "../../../contexts/order_context";
import { getOrderServices } from "../../../queries";
import { useController, useFormContext } from "react-hook-form";

const OrderServices = ({}) => {
  const { termId } = useContext(OrderContext);

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { field } = useController({ control, name: "services" });
  const [values, setValues] = useState([]);

  const orderServicesQuery = useQuery(
    ["services"],
    () => getOrderServices({ termId }),
    {
      onSuccess: (data) => {
        setValues(
          data.map((service) =>
            service.checked ? `${service.id} ${service.type}` : null
          )
        );
      },
    }
  );

  useEffect(() => {
    field.onChange(values);
  }, [values]);

  return (
    <OrderField title={I18n.t("js.order.fields.services")}>
      <div className="order-form__block-content row">
        <div className="services col">
          {orderServicesQuery.data?.map((service, index) => {
            return (
              <div className="form-check services__item" key={service.id}>
                <input
                  {...field}
                  id={service.id}
                  type="checkbox"
                  className={`services_checkbox form-check-input ${
                    service.required ? "gft" : ""
                  }`}
                  value={`${service.id} ${service.type}`}
                  defaultChecked={service.checked}
                  onChange={(e) => {
                    const valueCopy = [...values];
                    valueCopy[index] = e.target.checked ? e.target.value : null;
                    setValues(valueCopy);
                  }}
                  disabled={service.required ? "disabled" : ""}
                />
                <label className="form-check-label" htmlFor={service.id}>
                  <span className="label-title">{service.name}</span>
                  <span className="label-price">{service.price}</span>
                </label>
              </div>
            );
          })}
          <div className="row">
            <div className="col-lg-6"></div>
          </div>
        </div>
      </div>
    </OrderField>
  );
};

export default OrderServices;
